import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/intro-splash")({
  component: lazyRouteComponent(() => import("./-pages/admin.intro-splash")),
});
